var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _vm.rmcProteinFarmId === "0" &&
              (!_vm.detailForm.auditStatus ||
                _vm.detailForm.auditStatus === "Draft") &&
              (_vm.ms_roles.indexOf("QSPI_RMC_CHICK_SPONS_SUPP") !== -1 ||
                _vm.ms_roles.indexOf("QSPI_RMC_PORK_SPONS_SUPP") !== -1)
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROT_FARM_SAVE,
                          expression: "RMC_PROT_FARM_SAVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onAddSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.rmcProteinFarmId !== "0" &&
              (!_vm.detailForm.auditStatus ||
                _vm.detailForm.auditStatus === "Draft") &&
              (_vm.ms_roles.indexOf("QSPI_RMC_CHICK_SPONS_SUPP") !== -1 ||
                _vm.ms_roles.indexOf("QSPI_RMC_PORK_SPONS_SUPP") !== -1)
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROT_FARM_SAVE,
                          expression: "RMC_PROT_FARM_SAVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onEditSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.detailForm.auditStatus !== "PendingApproval" &&
              (_vm.ms_roles.indexOf("QSPI_RMC_CHICK_SPONS_SUPP") !== -1 ||
                _vm.ms_roles.indexOf("QSPI_RMC_PORK_SPONS_SUPP") !== -1)
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROT_FARM_SUBMIT,
                          expression: "RMC_PROT_FARM_SUBMIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _vm.detailForm.auditStatus === "PendingApproval" &&
              _vm.ms_roles.indexOf("QSPI_RMC_PROTEIN_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROT_FARM_APPROVE,
                          expression: "RMC_PROT_FARM_APPROVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onApprove },
                    },
                    [_vm._v("批准")]
                  )
                : _vm._e(),
              _vm.detailForm.auditStatus === "PendingApproval" &&
              _vm.ms_roles.indexOf("QSPI_RMC_PROTEIN_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROT_FARM_RETURN,
                          expression: "RMC_PROT_FARM_RETURN",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onReturn },
                    },
                    [_vm._v("退回")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: { model: _vm.detailForm, "label-width": "120px" },
            },
            [
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("农场清单")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Category3",
                                  prop: "category3Code",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isDisabled || _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.category3Code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "category3Code",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.category3Code",
                                    },
                                  },
                                  _vm._l(
                                    _vm.category3CodeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Sponsor",
                                  prop: "sponsorName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.sponsorName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "sponsorName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.sponsorName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "ASL Group",
                                  prop: "aslGroupCode",
                                  rules: _vm.rules.aslGroupCode,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    on: {
                                      change: _vm.getBreedingModeByAslGroup,
                                    },
                                    model: {
                                      value: _vm.detailForm.aslGroupCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "aslGroupCode",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.aslGroupCode",
                                    },
                                  },
                                  _vm._l(
                                    _vm.aslGroupCodeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.aslGroupName,
                                          value: item.aslGroupCode,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态", prop: "auditStatus" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.auditStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "auditStatus",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.auditStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.auditStatusOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "农场",
                                  prop: "farmName",
                                  rules: _vm.rules.farmName,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.farmName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "farmName", $$v)
                                    },
                                    expression: "detailForm.farmName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "追溯代码",
                                  prop: "traceCode",
                                  rules: _vm.rules.traceCode,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.traceCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "traceCode", $$v)
                                    },
                                    expression: "detailForm.traceCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "地址",
                                  prop: "farmAddress",
                                  rules: _vm.rules.farmAddress,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.farmAddress,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "farmAddress",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.farmAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "舍数",
                                  prop: "numOfHouse",
                                  rules: _vm.rules.numOfHouse,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.numOfHouse,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "numOfHouse",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.numOfHouse",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "养殖量/栋(万只)",
                                  prop: "breedingQuantityPerHouse",
                                  rules: _vm.rules.breedingQuantityPerHouse,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value:
                                      _vm.detailForm.breedingQuantityPerHouse,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "breedingQuantityPerHouse",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detailForm.breedingQuantityPerHouse",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "批出栏量(万只)",
                                  prop: "slaughterVolumePerBatch",
                                  rules: _vm.rules.slaughterVolumePerBatch,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value:
                                      _vm.detailForm.slaughterVolumePerBatch,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "slaughterVolumePerBatch",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detailForm.slaughterVolumePerBatch",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "年出栏量(万只)",
                                  prop: "slaughterVolumePerYear",
                                  rules: _vm.rules.slaughterVolumePerYear,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value:
                                      _vm.detailForm.slaughterVolumePerYear,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "slaughterVolumePerYear",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detailForm.slaughterVolumePerYear",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "养殖场性质",
                                  prop: "farmNature",
                                  rules: _vm.rules.farmNature,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isForbidden,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.farmNature,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "farmNature",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.farmNature",
                                    },
                                  },
                                  _vm._l(
                                    _vm.farmNatureOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "养殖模式",
                                  prop: "breedingMode",
                                  rules: _vm.rules.breedingMode,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isForbidden,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.breedingMode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "breedingMode",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.breedingMode",
                                    },
                                  },
                                  _vm._l(
                                    _vm.breedingModeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "是否有备案",
                                  prop: "isInspected",
                                  rules: _vm.rules.isInspected,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isForbidden,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    on: { change: _vm.isInspectedChange },
                                    model: {
                                      value: _vm.detailForm.isInspected,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "isInspected",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.isInspected",
                                    },
                                  },
                                  _vm._l(
                                    _vm.isInspectedOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                class:
                                  _vm.detailForm.isInspected == "Y"
                                    ? "is-required"
                                    : "",
                                attrs: {
                                  label: "商检局备案号",
                                  prop: "inspectionNo",
                                  rules: _vm.rules.inspectionNo,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled:
                                      _vm.detailForm.isInspected == "N" ||
                                      _vm.isForbidden,
                                  },
                                  model: {
                                    value: _vm.detailForm.inspectionNo,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "inspectionNo",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.inspectionNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "场长",
                                  prop: "farmDirector",
                                  rules: _vm.rules.farmDirector,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.farmDirector,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "farmDirector",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.farmDirector",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "联系电话",
                                  prop: "phoneNo",
                                  rules: _vm.rules.phoneNo,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.phoneNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "phoneNo", $$v)
                                    },
                                    expression: "detailForm.phoneNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "农场状态",
                                  prop: "farmStatus",
                                  rules: _vm.rules.farmStatus,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isForbidden,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.farmStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "farmStatus",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.farmStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.farmStatusOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.$route.query.from === "edit"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "上次修改原因",
                                      prop: "lastUpdateReason",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: "",
                                        type: "textarea",
                                        maxlength: "1000",
                                        "show-word-limit": "",
                                        autosize: { minRows: 4, maxRows: 6 },
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: _vm.lastUpdateReason,
                                        callback: function ($$v) {
                                          _vm.lastUpdateReason = $$v
                                        },
                                        expression: "lastUpdateReason",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "修改原因",
                                  prop: "updateReason",
                                  rules: _vm.rules.updateReason,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.updateReason,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "updateReason",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.updateReason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            title: "退回意见",
            visible: _vm.dialogReturnVisible,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogReturnVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "returnForm",
              attrs: { model: _vm.returnForm, rules: _vm.returnFormRules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "returnedReason" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "1000",
                      "show-word-limit": "",
                      type: "textarea",
                      autosize: { minRows: 4, maxRows: 6 },
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.returnForm.returnedReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.returnForm, "returnedReason", $$v)
                      },
                      expression: "returnForm.returnedReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.onClose } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }